import { Schema } from "effect";
export const UserConfigItem = Schema.declare((input) => typeof input === "string", {
    identifier: "UserConfigItem",
});
export const UserConfig = Schema.Struct({
    upn: Schema.String,
    configItems: Schema.Array(UserConfigItem),
});
